import React from "react";

import Block from "./Block";

const PatternOffset = ({
  cols,
  rows,
  updatePattern,
  pattern,
  color,
  defaultColor,
  rotation = 0,
}) => {
  const generateRows = () => {
    const beadRows = [];

    let gridTotalNumberBeads = cols * rows;
    let totalNumberBeads = Math.ceil(cols * rows + rows / 2);

    let counter = totalNumberBeads + 1;

    for (let i = rows - 1; i >= 0; i--) {
      let numCols = cols || 8;

      if (i % 2 === 0) {
        numCols = numCols + 1;
      }

      const gridItems = [];

      for (let j = 0; j < numCols; j++) {
        counter--;

        gridItems.unshift(
          <Block
            defaultColor={defaultColor}
            paletteColor={color}
            pattern={pattern}
            updatePattern={updatePattern}
            row={rows - i}
            col={j + 1}
            key={j}
            beadNumber={counter}
            disable={counter > gridTotalNumberBeads}
          />
        );
      }

      beadRows.push(<tr key={i}>{gridItems}</tr>);
    }

    return beadRows;
  };

  return (
    <div
      className="pattern pattern-offset"
      style={{
        transform: `rotate(${rotation}deg)`,
        transformOrigin: "center",
      }}
    >
      <table className={`offset ${rows % 2 === 0 ? "even" : "odd"}`}>
        <tbody>{generateRows()}</tbody>
      </table>
    </div>
  );
};

export default PatternOffset;
